import type { PricelistGridCellDto } from "../api/schemas";

export type ProductJson = Record<string, unknown>;

export type DocumentType = "quotation" | "proforma";

export type RowPricingMode = "global" | "row" | "manual";

export type ComparisonPricingMode = "discount" | "manual";

export interface QuoteItem {
  product: ProductJson;
  brand: string;
  tag: string;
  discount: number;
  loading_frls: number;
  loading_pvc: number;
  quantity: number;
  user_base_price: number;
  markup?: number;
}

export interface QuotationRequest {
  show_price_breakdown?: boolean;
  items: QuoteItem[];
  delivery_charges: number;
  to?: string[];
  terms_and_conditions?: string[];
}

export interface CartItem {
  id: string;
  brand: string;
  category: string;
  pricelistDisplayName: string;
  tag: string;
  product: ProductJson;
  description: string;
  listPrice: number;
  quantity: number | undefined;
  discount: number | undefined;
  rate: number | undefined;
  markup: number | undefined;
  loadingFrls: boolean;
  loadingPvc: boolean;
  supportsFrls: boolean;
  supportsPvc: boolean;
  pricingMode?: RowPricingMode;
}

export interface ComparisonRow {
  cartItemId: string;
  listPrice: number | undefined;
  discount: number | undefined;
  rate: number | undefined;
  pricingMode: ComparisonPricingMode;
  warning: string | undefined;
}

export interface ComparisonState {
  brand: string;
  rows: ComparisonRow[];
}

export interface WorkspaceState {
  showPriceBreakdown: boolean;
  documentType: DocumentType;
  selectedBrand: string;
  selectedCategory: string;
  selectedPricelistTag: string;
  globalDiscount: number | undefined;
  globalMarkup: number | undefined;
  deliveryCharges: number | undefined;
  customerLines: string;
  termsText: string;
  cart: CartItem[];
  comparison: ComparisonState;
}

export function makeCartItemId(cell: PricelistGridCellDto, tag: string): string {
  return `${tag}::${makeCartItemGridKey(cell)}`;
}

export function makeCartItemGridKey(cell: PricelistGridCellDto): string {
  return `${cell.row}::${cell.column}::${cell.label}`;
}

export function cartItemGridKey(item: CartItem): string {
  return item.id.split("::").slice(1).join("::");
}
